export default __webpack_public_path__ + "dist/assets/admin-bg.png";